import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { signUp, signInWithRedirect } from 'aws-amplify/auth';
import { showAlert } from "utils/Alert";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from "./style.module.scss";
import { ReactComponent as Logo } from 'assets/images/svg/logo.svg';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useCookies } from "react-cookie";
import cx from "classnames";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  FormGroup,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import GoogleOAuthButton from "components/GoogleOAuthButton";
import { ANALYTIC_EVENT_ACTIONS, ANALYTIC_EVENT_CATEGORIES, REFERAL_USER_COOKIE_NAME } from "utils/Constants";
import AnalyticButton from "components/AnalyticButton";
import PasswordInput from "components/DynamicForm/components/PasswordInput";

const Register = (props) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const referalUser = searchParams.get("referal");
  const [formData, setFormData] = useState({});
  const [cookies, setCookie] = useCookies([REFERAL_USER_COOKIE_NAME]);

  useEffect(() => {
    if (referalUser) {
      setCookie(REFERAL_USER_COOKIE_NAME, referalUser, {
        maxAge: 300
      });
    }
  }, [referalUser]);

  const setFormValue = (fieldName, e) => {
    formData[fieldName] = e.target.value;
    setFormData(formData);
  }

  const formatPhoneNumber = (phone) => {
    let formatedPhone = phone.replace(/\s/g, '');
    formatedPhone = formatedPhone.replace(/-|\+/g, '');
    formatedPhone = formatedPhone.replace(/\(|\)/g, '');
    if (formatedPhone.length > 8) {
      formatedPhone = `+${formatedPhone}`;
    } else {
      formatedPhone = `+506${formatedPhone}`;
    }

    return formatedPhone;
  }

  const registerUser = (e) => {
    e.preventDefault();
    const { password, name, repassword, username } = formData;
    if (!username || !name || !password || !repassword) {
      // if (!username || !name || !password || !phone_number || !repassword) {
      showAlert("danger", "Por favor ingrese la informacion solicitada");
      return;
    }

    if (password !== repassword) {
      showAlert("danger", "La confirmacion de contraseña y la contraseña no son iguales");
      return;
    }

    const trimUserName = username.replace(/\s/g, '').toLowerCase();
    // const phone = formatPhoneNumber(phone_number);

    signUp({
      username: trimUserName,
      password,
      options: {
        userAttributes: {
          name: name,
          email: trimUserName,
          // "custom:tel_home": phone,
          // "custom:tel_mobile": phone
        }
      }
    }).then((u) => {
      navigate("/auth/validate-account");
    }).catch((e) => {
      console.log("Sign up error", e);
      let message = "";
      switch (e.name) {
        case "UsernameExistsException":
          message = "Ya existe una usuario con el correo ingresado";
          break;
        case "InvalidPasswordException":
          message = "La contraseña debe tener al menos 8 caracteres";
          break;

        default:
          message = "No ha sido posible crear el usuario";
          break;
      }
      showAlert("danger", message);
    });
  }

  return (
    <div className={styles.registerContent}>
      <div className={styles.logoWrapper} >
        <a title="Unboxing Homepage" href="/" >
          <Logo className={styles.logo} />
        </a>
      </div>
      <Container>
        <Row className={cx(["align-items-center", styles.registerContainer])}>
          <Col lg="5" md="5">
            <div className={styles.loginDetails}>
              <div>
                <div className="icon icon-primary">
                  <i className="nc-icon nc-tv-2" />
                </div>
                <div className="description">
                  <h5 className="info-title">Casillero Gratuito en Miami</h5>
                  <p className="description">
                    Tu espacio exclusivo sin costo adicional. ¡Comienza a recibir sin límites y ahorra con nuestro casillero gratuito en Miami!
                  </p>
                </div>
              </div>
              <div>
                <div className="icon icon-primary">
                  <i className="nc-icon nc-html5" />
                </div>
                <div className="description">
                  <h5 className="info-title">Pagas solo por la libras exactas que traes</h5>
                  <p className="description">
                    Sin sorpresas. Paga solo por lo que traes. Nuestro sistema justo garantiza que cada libra cuenta, maximizando tu ahorro.
                  </p>
                </div>
              </div>
              <div>
                <div className="icon icon-info">
                  <i className="nc-icon nc-atom" />
                </div>
                <div className="description">
                  <h5 className="info-title">Sistema Inteligente de seguimiento de paquetes</h5>
                  <p className="description">
                    Control total en tus manos. Nuestro sistema inteligente de seguimiento de paquetes te mantiene informado en cada paso del camino.
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col className="mr-auto" lg="4" md="6">
            <Card className={styles.cardSignUp}>
              <CardHeader className={styles.header}>
                <CardTitle tag="h4">Crear una Cuenta</CardTitle>
                <div className="social">
                  {/* <Button
                    color="facebook"
                    block
                    className="btn-round mb-3"
                    onClick={() => signInWithRedirect({ provider: 'Facebook' })}
                  >
                    <FacebookIcon className={styles.facebookButton} />
                    Inicia sesion con Facebook
                  </Button> */}
                  <div className="text-center">
                    <GoogleOAuthButton
                      className={styles.googleButton}
                      onClick={() => signInWithRedirect({ provider: 'Google' })}
                      btnLabel="Sign up with Google">
                    </GoogleOAuthButton>
                  </div>
                  <hr />
                  <p className="card-description">O usa tu correo electrónico</p>
                </div>
              </CardHeader>
              <CardBody>
                <Form action="#" className="form" method="">
                  <FormGroup>
                    <InputGroup>
                      <InputGroupText>
                        <FontAwesomeIcon icon="fa-solid fa-user" />
                      </InputGroupText>
                      <Input
                        placeholder="Nombre"
                        type="text"
                        name="name"
                        onChange={(e) => setFormValue("name", e)}
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup>
                    <InputGroup>
                      <InputGroupText>
                        <FontAwesomeIcon icon="fa-solid fa-envelope" />
                      </InputGroupText>
                      <Input
                        placeholder="Email..."
                        type="email"
                        name="email"
                        onChange={(e) => setFormValue("username", e)}
                      />
                    </InputGroup>
                  </FormGroup>
                  {/* <FormGroup>
                    <InputGroup>
                      <InputGroupText>
                        <FontAwesomeIcon icon="fa-solid fa-envelope" />
                      </InputGroupText>
                      <Input
                        placeholder="Telefono"
                        type="tel"
                        name="phone_number"
                        onChange={(e) => setFormValue("phone_number", e)}
                      />
                    </InputGroup>
                  </FormGroup> */}
                  <FormGroup>
                    <PasswordInput
                      placeholder="Contraseña"
                      name="password"
                      onChange={(e) => setFormValue("password", e)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <PasswordInput
                      placeholder="Confirme la Contraseña"
                      name="repassword"
                      onChange={(e) => setFormValue("repassword", e)}
                    />
                  </FormGroup>
                </Form>
              </CardBody>
              <CardFooter>
                <div className="d-flex justify-content-end">
                  <AnalyticButton
                    tracking={{
                      category: ANALYTIC_EVENT_CATEGORIES.USER,
                      action: ANALYTIC_EVENT_ACTIONS.CLICK_REGISTER,
                      label: "Submit Register"
                    }}
                    className="btn-round align-right"
                    color="success"
                    onClick={(e) => registerUser(e)}
                  >
                    Registrarse
                  </AnalyticButton>
                </div>
              </CardFooter>
              <CardFooter>
                <div className="d-flex justify-content-between align-items-center">
                  Ya tenes cuenta?
                  <AnalyticButton
                    tracking={{
                      category: ANALYTIC_EVENT_CATEGORIES.USER,
                      action: ANALYTIC_EVENT_ACTIONS.CLICK_LOGIN,
                      label: "Go To login"
                    }}
                    className="btn-round"
                    color="primary"
                    onClick={(e) => navigate("/")}
                  >
                    Iniciar Session
                  </AnalyticButton>
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Register;